/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "./Lang"
import BaseCom from "./BaseCom";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import Patient from "./Patient";
import { qreq } from "../shared/qrequest";
import LoadingAlert from "./LoadingAlert";
import Alert from "./Alert";
import Card from "./Card";
import FormInput from "./FormInput";
import SignatureCanvas from "react-signature-canvas";
import Icon from "./Icon";
import React from "react";
import { Modal } from "react-bootstrap";

class MedicalReleaseRequest extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {}
        };
        this.sigCanvasRef = React.createRef();
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        qreq.get('/api/document/medical-release/get/' + this.props.params.uniqueIdent + '/public', j => {
            if (j.item)
                this.setState({ item: j.item });
            else
                this.setState({ error: j.errorMessage });
        }, () => {
            this.setState({ error: 'Unknown error. Please close this page and click the link again.' });
        });
    }

    submit(e) {
        if (e) e.preventDefault();
        if (this.sigCanvasRef.current.isEmpty()) {
            this.alert('Please sign the form before submitting.');
            return;
        }
        var info = { ...this.state.item, ...this.state.info };
        info.base64Signature = this.sigCanvasRef.current.getTrimmedCanvas().toDataURL('image/png').split(',')[1];
        this.setState({ submitting: true });
        qreq.post('/api/document/medical-release/fill', info, j => {
            if (j.errorCode === 0) {
                this.setState({ success: true });
            }
            else {
                this.setState({ submitting: false });
                this.alert(j.errorMessage);
            }
        }, () => {
            this.setState({ submitting: false });
            this.unkownErrorCallback();
        });
    }

    render() {
        if (this.state.error)
            return <div className="container-fluid"><h1><L>Error</L></h1><Alert type="warning">{this.state.error}</Alert></div>;
        if (!this.state.item)
            return <LoadingAlert />
        if (this.state.success)
            return <div className="container-fluid"><h1><L>Success</L></h1><Alert type="success"><L>Medical Release signed successfully.</L></Alert><p><L>You may now close this page.</L></p></div>;

        return <div className="container-fluid">
            <Modal show={this.state.showDisclaimer} onHide={() => this.setState({ showDisclaimer: false })} size="xl">
                <Modal.Header closeButton className="text-uppercase"><L>Important information about the authorization to disclose protected health information</L></Modal.Header>
                <Modal.Body>
                    <p>
                        The Attorney General of Texas has adopted a standard Authorization to Disclose Protected Health Information in accor dance with
                        Texas Health & Safety Code § 181.154(d). This form is intended for use in complying with the requirement s of the Health Insurance
                        Portability and Accountability Act and Privacy Standards (HIPAA) and the Texas Medical Privacy Act (Texas Health & Safety
                        Code, Chapter 181). <strong><L>Covered Entities may use this form or any other form that complies with HIPAA, the Texas Medical
                            Privacy Act, and other applicable laws.</L></strong>
                    </p>
                    <p>
                        Covered entities, as that term is defined by HIPAA and Texas Health & Safety Code § 181.001, must obtain a signed autho rization
                        from the individual or the individual's legally authorized representative to electronically disclose that individual's protected health
                        information. Authorization is not required for disclosures related to treatm ent, payment, health care operations, performing certain
                        insurance functions, or as may be otherwise authorized by law . (Tex. Health & Safety Code §§ 181.154(b),(c), § 241.153; 45
                        C.F.R. §§ 164.502(a)(1); 164.506, and 164.508).
                    </p>
                    <p><L>The authorization provided by use of the form means that the or ganization, entity or person authorized can disclose, commu -
                        nicate, or send the named individual's protected health information to the organization, entity or p erson identified on the form,
                        including through the use of any electronic means.</L></p>

                    <p>
                        <strong><L>Definitions</L></strong> - In the form, the terms “treatment,” “healthcare operations,” “psychotherapy notes,” and “protected health informa -
                        tion” are as defined in HIPAA (45 CFR 164.501). “Legally authorized representative” as used in the form includes any person
                        authorized to act on behalf of another individual. (Tex. Occ. Code § 151.002(6); Tex. Health & Safety Code §§ 166.164, 241.151;
                        and Tex. Probate Code § 3(aa)).
                    </p>
                    <p>
                        <strong><L>Health Information to be Released</L></strong> - If “All Health Information” is selected for release, health i nformation includes, but is not limited
                        to, all records and other information regarding health his tory, treatment, hospitalization, tests, and outpatient care, and a lso
                        educational records that may contain health information. As indicated on the form, specific authorization is required for the release
                        of information about certain sensitive conditions, including:
                    </p>
                    <ul>
                        <li>Mental health records (excluding “psychotherapy notes” as defin ed in HIPAA at 45 CFR 164.501).</li>
                        <li><L>Drug, alcohol, or substance abuse records.</L></li>
                        <li><L>Records or tests relating to HIV/AIDS.</L></li>
                        <li>Genetic (inherited) diseases or tests (except as may be prohibi ted by 45 C.F.R. § 164.502).</li>
                    </ul>
                    <p>Note on Release of Health Records - This form is not required for the permissible disclosure of an individual's protected health
                        information to the individual or the individual's legally authorized representative. (45 C.F.R. §§ 164.502(a)(1)(i), 164.524; Tex.
                        Health & Safety Code § 181.102). If requesting a copy of the individual' s health records with this form, state and federal law
                        allows such access, unless such access is determined by the physician or mental h ealth provider to be harmful to the individu -
                        al's physical, mental or emotional health. (Tex. Health & Safety Code §§ 181.102, 611.0045(b); Tex. Occ. Code § 159.006(a); 45
                        C.F.R. § 164.502(a)(1)). If a healthcare provider is specified in t he “Who Can Receive and Use The Health Information” section of
                        this form, then permission to receive protected health information also includes physicians, other health care providers (such as
                        nurses and medical staff) who are involved in the individual's medical care at that entity's facility or that person's office, and health
                        care providers who are covering or on call for the specified per son or organization, and staff members or agents (such as busi -
                        ness associates or qualified services organizations) who carry o ut activities and purposes permitted by law for that specified c overed
                        entity or person. If a covered entity other than a healthc are provider is specified, then permission to receive protected health
                        information also includes that organization's staff or agents and subcontractors who carry out activities and pur poses permitted by
                        this form for that organization. Individuals may be entitled to restrict certain disclosures of protected health information r elated to
                        services paid for in full by the individual (45 C.F.R. § 164.522(a)(1)(vi)).</p>
                    <p>Authorizations for Sale or Marketing Purposes - If this authorization is being made for sale or marketing purposes and the covered
                        entity will receive direct or indirect remuneration from a third party in connection with the use or disclosure of the individual's
                        information for marketing, the authorization must clearly indicate to the individual that such remuneration is involved. (Tex. Health &
                        Safety Code §181.152, .153; 45 C.F.R. § 164.508(a)(3), (4)).</p>
                    <p><strong><L>Limitations of this form</L></strong> - This authorization form shall not be used for the disclosure of
                        any health information as it relates to: (1) health benefits plan enrollment and/or related
                        enrollment determinations (45 C.F.R. § 164.508(b)(4)(ii), .508(c)(2)(ii); (2) psychotherapy
                        notes (45 C.F.R. § 164.508(b)(3)(ii); or for research purposes (45 C.F.R. § 164.508(b)(3)(i)).
                        <strong>
                            Use of this form does not exempt any entity from compliance with applicable federal
                            or state laws or regulations regarding access, use or disclosure of health information
                            or other sensitive personal information (e.g., 42 CFR Part 2, restricting use of
                            information pertaining to drug/alcohol abuse and treatment), and does not entitle
                            an entity or its employees, agents or assigns to any limitation of liability for acts or
                            omissions in connection with the access, use, or disclosure of health information
                            obtained through use of the form.
                        </strong></p>
                    <p><strong><L>Charges</L></strong> - Some covered entities may
                        charge a retrieval/processing fee and
                        for copies of medical records.
                        (Tex. Health & Safety Code § 241.154).</p>
                    <p><strong><L>Right to Receive Copy</L></strong><L>- The
                        individual and/or the individual's legally
                        authorized representative has a right to
                        receive a copy of this authorization.</L></p>
                </Modal.Body>
            </Modal>
            <h1><L>AUTHORIZATION TO DISCLOSE PROTECTED HEALTH INFORMATION</L></h1>
            <p><L>Please read this entire form before signing and complete all the sections that
                apply to your decisions relating to the disclosure of protected health information.
                Covered entities as that term is de ned by HIPAA and Texas Health & Safety
                Code § 181.001 must obtain a signed authorization from the individual or the
                individual's legally authorized representative to electronically disclose that individual's protected health information. Authorization is not required for disclosures
                related to treatment, payment, health care operations, performing certain
                insurance functions, or as may be otherwise au- thorized by law. Covered entities
                may use this form or any other form that complies with HIPAA, the Texas Medical
                Privacy Act, and other applicable laws. Individuals cannot be denied treatment
                based on a failure to sign this authorization form, and a refusal to sign this form
                will not affect the payment, enrollment, or eligibility for benefits</L></p>
            <Patient item={this.state.item.patient} readOnly requestAddress />
            <form onSubmit={this.submit}>
                <Card title="Organization holding Medical Records">
                    <FormInput model={this.state.info} name="orgName" label="Person/Organization Name (Optional)" type="text" placeholder="Person or Organization holding the medical records..." autoFocus />
                    <FormInput model={this.state.info} name="phone" label="Phone Number (Optional)" type="tel" placeholder="000 000 0000" />
                </Card>
                <p>
                    <strong><L>EFFECTIVE TIME PERIOD.</L></strong> This authorization is valid for one hundred and eighty (180) days from the date of signing, unless otherwise revoked.
                </p>
                <p>
                    <strong>RIGHT TO REVOKE:</strong><L>I understand that I can withdraw my permission at any time by giving written notice stating my intent to revoke this authorization
                        to the person or organization named under “WHO CAN RECEIVE AND USE THE HEALTH INFORMATION.” I understand that
                        prior actions taken in reliance on this authorization by entities that had permission to access my health information will not be affected.</L></p>
                <p>
                    <strong>SIGNATURE AUTHORIZATION:</strong> I have read this form and agree to the uses and disclosures of the information as described. I understand
                    that refusing to sign this form does not stop disclosure of health information that has occurred prior to revocation or that
                    is otherwise permitted by law without my specific authorization or permission, including disclosures to covered entities as provided
                    by Texas Health & Safety Code § 181.154(c) and/or 45 C.F.R. § 164.502(a)(1). I understand that information disclosed pursuant
                    to this authorization may be subject to re-disclosure by the recipient and may no longer be protected by federal or state privacy laws.
                </p>
                <Card title="Signature">
                    <div className="text-center">
                        <label className="form-label"><L>Signature of Individual or Individual's Legally Authorized Representative</L></label>
                    </div>
                    <div className="d-grid align-items-center justify-content-center">
                        <button type="button" className="btn btn-secondary" onClick={() => this.sigCanvasRef.current.clear()}>Reset Signature</button>
                        <SignatureCanvas ref={this.sigCanvasRef} canvasProps={{ width: 400, height: 200, className: 'border' }} />
                    </div>
                    <p className="my-3 text-center"><L>Please read the</L> <span role="button" className="text-primary" onClick={() => this.setState({ showDisclaimer: true })}>important information about the authorization to disclose protected health information.</span>
                    </p>
                    <div className="my-3 text-center">
                        <button type="submit" className="btn btn-primary btn-lg" disabled={this.state.submitting}><Icon icon="faCaretRight" /> <L>Submit</L></button>
                    </div>
                </Card>
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(MedicalReleaseRequest);